// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"b5e698c8","688":"786c2883"}[chunkId] + ".chunk.js";
};